<template>
  <v-select
    :options="options"
    :label="label"
    :value="selected"
    class="custom-select"
    @input="$emit('setSelected', $event)"
    @open="$emit('setOpen', true)"
    @close="$emit('setOpen', false)"
  ></v-select>
</template>

<script>
  import vSelect from 'vue-select'
  import 'vue-select/dist/vue-select.css'

  export default {
    name: 'select-wrapper',
    components: {
      'v-select': vSelect
    },
    props: {
      options: { type: Array, default: () => [] },
      label: { type: String, default: '' },
      selected: { type: String, default: '' }
    },
    emits: ['setSelected', 'setOpen'],
    data () {
      return {
      }
    }
  }
</script>

<style>
/* задаём переменные на корневом элементе компонента */
.custom-select {
  --vs-controls-color: #2C3030;
  --vs-border-color: #DDDDDD;
  --vs-border-radius: 8px;
  --vs-font-size: 18px;
  --vs-line-height: 30px;
  --vs-dropdown-option--active-bg: #00ccb4;
  --vs-dropdown-option--active-color: #2C3030;
}

/* изменения шрифта/веса для выбранного и меню */
.custom-select .vs__selected,
.custom-select .vs__dropdown-menu {
  font-size: 18px !important;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/vue/common/UI/SelectWrapper.vue